import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Header from './Header'

// Wraps pages that need a login. Waits for the saved session to load before
// deciding — otherwise a link from an email (e.g. "New booking request" →
// /my-bookings) bounced people away before their login was read. Only
// genuinely logged-out visitors go to sign-in, and they come back to the
// exact page (including ?booking=… etc.) afterwards.
export default function ProtectedRoute({ children, allowDemo = false }) {
const { user, loading } = useAuth()
const location = useLocation()

if (allowDemo && process.env.NODE_ENV === 'development') return children

if (loading) return (
<div>
<Header />
<div className="spinner-wrap"><div className="spinner" /></div>
</div>
)

if (!user) {
const next = location.pathname + location.search
return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />
}

return children
}
